import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7baf2fb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center mb-10\" data-v-7baf2fb9><i class=\"bi bi-check-circle icon\" data-v-7baf2fb9></i></div><h2 class=\"text-center mb-6\" data-v-7baf2fb9> Pagamento Confirmado! </h2><p class=\"fs-6 text-center\" data-v-7baf2fb9> Seu pagamento foi confirmado com sucesso! <br data-v-7baf2fb9> Você agora é membro oficial do Hacking Club e tem acesso ilimitado a todos os recursos e conteúdos da plataforma.<br data-v-7baf2fb9> Sinta-se à vontade para explorar todos os laboratórios, aulas, cursos e informações exclusivas disponíveis para você como membro. <br data-v-7baf2fb9><br data-v-7baf2fb9> O Hacking Club está comprometido em oferecer a você as informações mais atualizadas e relevantes no campo do hacking, ajudando você a aprimorar suas habilidades e conhecimentos. Aproveite ao máximo sua associação explorando todos os benefícios e vantagens que agora estão ao seu alcance.<br data-v-7baf2fb9><br data-v-7baf2fb9> Se você tiver alguma dúvida ou precisar de assistência adicional, não hesite em entrar em contato conosco. Estamos aqui para apoiá-lo em cada etapa de sua jornada no mundo do hacking.<br data-v-7baf2fb9><br data-v-7baf2fb9> Não se esqueça de entrar para a nossa comunidade no Discord e participar de nossos eventos e atividades exclusivas para membros. Estamos ansiosos para conhecê-lo e ajudá-lo a alcançar seus objetivos no hacking.<br data-v-7baf2fb9></p>", 3)
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "bi bi-soundwave" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Ir para o conteúdo ")

import { onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// when component is mounted, scroll to top
onMounted(() => {
  window.scrollTo(0, 0)
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "btn btn-success mt-8"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _hoisted_7
        ]),
        _: 1
      })
    ])
  ]))
}
}

})